module.exports = __webpack_public_path__ + "img/bg_hero_1.1f5ec9b6.svg";